import { queryOptions } from '@tanstack/react-query'

import { USER_QUERY_KEYS } from '@/queries/user'
import { listCompanies } from '@/services/fintalk/services/fintalk-backoffice/companies/list'

export const COMPANIES_QUERY_KEYS = {
  root: (userId: string) =>
    [...USER_QUERY_KEYS.scope(userId), 'companies'] as const,
  // ex: ['user', '123', 'companies']

  scope: (userId: string, companyId: string) =>
    [...COMPANIES_QUERY_KEYS.root(userId), companyId] as const,
  // ex: ['user', '123', 'companies', '456']

  list: (userId: string) =>
    [...COMPANIES_QUERY_KEYS.root(userId), 'list'] as const,
  // ex: ['user', '123', 'companies', 'list']
}

export const companiesQueryOptions = (userId: string) => {
  return queryOptions({
    queryKey: COMPANIES_QUERY_KEYS.list(userId),
    queryFn: () => listCompanies(),
  })
}
